import { v4 as uuidv4 } from 'uuid';
import { Flex } from '@grupoboticario/flora-react';

import { app } from 'core';
import { ProductCardSkeleton } from 'ui/components';

export const ShowcaseSkeleton = () => {
  const isMobile = app.hooks.useApp('isMobile');
  const showcaseSize = isMobile ? 2 : 4;

  return (
    <Flex gap="$4" wrap="nowrap" justify="center">
      {[...Array(showcaseSize)].map(() => (
        <ProductCardSkeleton key={`skeleton-${uuidv4()}`} />
      ))}
    </Flex>
  );
};
